import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";

import { MDBContainer, MDBRow, MDBCol } from "mdbreact";

import Scene from "../components/Scene";
import View from "../components/View";
import Video from "../components/Video";

import Info from "../components/Info";

import "./styles.css";

const MediaButton = ({ label, iconSrc, iconAlt, onClick }) => (
  <div className="d-inline-block mr-3 text-center">
    <button
      type="button"
      className="btn btn-info btn-sm"
      title={label}
      onClick={onClick}
    >
      <img className="icon-info" src={iconSrc} alt={iconAlt} />
    </button>
    <div>{label}</div>
  </div>
);

const InfoProject = ({ isOpen, setIsOpen, tour, sale }) => {
  const [scene, setScene] = useState(0);
  const [type, setType] = useState("");

  const toggle = () => {
    setIsOpen(false);
  };

  useEffect(() => {
    if (tour.scenes && tour.scenes.length > 0) {
      setType("image");
    } else if (tour.images && tour.images.length > 0) {
      setType("image");
    } else if (tour.videos && tour.videos.length > 0) {
      setType("video");
    }
  }, [tour]);

  useEffect(() => {
    if (!isOpen) {
      return undefined;
    }

    const scrollY = window.scrollY;
    const html = document.documentElement;
    const body = document.body;

    html.classList.add("project-modal-open");
    body.classList.add("project-modal-open");
    body.style.top = `-${scrollY}px`;

    return () => {
      html.classList.remove("project-modal-open");
      body.classList.remove("project-modal-open");
      body.style.top = "";
      window.scrollTo(0, scrollY);
    };
  }, [isOpen]);

  if (!isOpen) {
    return null;
  }

  return ReactDOM.createPortal(
    <React.Fragment>
      <div className="project-modal-backdrop fade show" onClick={toggle} />
      <div
        className="modal fade show d-block project-modal"
        tabIndex="-1"
        role="dialog"
        aria-modal="true"
        onClick={toggle}
      >
        <div
          className="modal-dialog modal-lg project-modal-dialog"
          role="document"
          onClick={(e) => e.stopPropagation()}
        >
          <div className="modal-content project-modal-content">
            <div className="modal-header">
              <h5 className="modal-title">
                {tour.title}
                {tour.sold ? (
                  <span className="sold-label">{tour.sold}</span>
                ) : null}
              </h5>
              <button
                type="button"
                className="close"
                aria-label="Cerrar"
                onClick={toggle}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body project-modal-body">
              <MDBContainer>
                <MDBRow>
                  <MDBCol>
                    {tour.images && tour.images.length > 0 ? (
                      <MediaButton
                        label="Ver Imágenes"
                        iconSrc="../images/icons/foto.png"
                        iconAlt="imágenes"
                        onClick={() => setType("image")}
                      />
                    ) : null}
                    {tour.videos && tour.videos.length > 0 ? (
                      <MediaButton
                        label="Ver Video"
                        iconSrc="../images/icons/video.png"
                        iconAlt="video"
                        onClick={() => setType("video")}
                      />
                    ) : null}
                    {tour.scenes && tour.scenes.length > 0 ? (
                      <MediaButton
                        label="Ver Panorámica 360°"
                        iconSrc="../images/icons/360.png"
                        iconAlt="Tour 360°"
                        onClick={() => setType("360")}
                      />
                    ) : null}
                  </MDBCol>
                </MDBRow>
                <MDBRow>
                  {type === "360" ? (
                    <MDBCol size="12" lg="8">
                      <Scene
                        folder={tour.folder}
                        type={tour.type}
                        scene={tour.scenes[scene]}
                        setScene={setScene}
                      />
                    </MDBCol>
                  ) : null}
                  {type === "image" ? (
                    <MDBCol size="12" lg="8">
                      <View
                        folder={tour.folder}
                        type={tour.type}
                        images={tour.images}
                      />
                    </MDBCol>
                  ) : null}
                  {type === "video" ? (
                    <MDBCol size="12" lg="8">
                      <Video
                        folder={tour.folder}
                        type={tour.type}
                        videos={tour.videos}
                      />
                    </MDBCol>
                  ) : null}
                  <MDBCol size="12" lg="4">
                    <Info
                      sale={sale}
                      type={type}
                      tour={tour}
                      scene={scene}
                      setScene={setScene}
                    />
                  </MDBCol>
                </MDBRow>
              </MDBContainer>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>,
    document.body
  );
};

export default InfoProject;
